import React from "react"
import "../styles/Livescoring/Livescoring.css"
import LivescoringPage from "../components/Livescoring/LivescoringPage"
import LivescoringComponent from "../components/Livescoring/LivescoringComponent"

const Livescoring = ({
    competitionName,
    clubName,
    livescoringData = null,
    livescoringHandicapData = null,
    livescoringScratchData = null,
    rowLimit,
    competitionId,
    section,
    teeTime,
    filteredByCalculation = false,
    isProduction = true,
    calculation = null,
    showToggle = false,
    socketChannel
}) => {

    return (
        <div className={`livescoring-page ${section}`}>
            {
                (
                    "livescoring" === section
                    || "ecard" === section
                ) ?
                    <LivescoringPage
                        competitionName={competitionName}
                        clubName={clubName}
                        livescoringData={livescoringData}
                        livescoringScratchData={livescoringScratchData}
                        livescoringHandicapData={livescoringHandicapData}
                        section={section}
                        rowLimit={rowLimit}
                        competitionId={competitionId}
                        teeTime={teeTime}
                        filteredByCalculation={filteredByCalculation}
                        isProduction={isProduction}
                        calculation={calculation}
                        showToggle={showToggle}
                        socketChannel={socketChannel}
                    />

                    :

                    <LivescoringComponent
                        competitionName={competitionName}
                        calculation={calculation}
                        clubName={clubName}
                        livescoringData={livescoringData}
                        section={section}
                        rowLimit={rowLimit}
                        competitionId={competitionId}
                        teeTime={teeTime}
                        filteredByCalculation={filteredByCalculation}
                        isProduction={isProduction}
                        positionCalculationKey={calculation}
                        socketChannel={socketChannel}
                    />
            }
        </div>
    )
}

export default Livescoring
